import { render, staticRenderFns } from "./LpuDoctors.vue?vue&type=template&id=46072000&"
import script from "./LpuDoctors.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuDoctors.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46072000')) {
      api.createRecord('46072000', component.options)
    } else {
      api.reload('46072000', component.options)
    }
    module.hot.accept("./LpuDoctors.vue?vue&type=template&id=46072000&", function () {
      api.rerender('46072000', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuDoctors.vue"
export default component.exports